<template>
  <a-card class="Questiongrouptemplate">
    <div :class="advanced ? 'search' : null">
      <a-form layout="horizontal" class="searchForm">
        <div :class="advanced ? null: 'fold'">
          <a-form-item label="状态" :labelCol="{span: 6}" :wrapperCol="{span: 17, offset: 1}">
            <a-select allowClear default-value="lucy" v-model="search.status" placeholder="请选择状态" style="width:172px;">
              <a-select-option value="true">启用</a-select-option>
              <a-select-option value="false">禁用</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-left: 40px;">
            <div class="sbtn">
              <a-button type="primary" @click="getList()">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetSearch()">重置</a-button>
              <a-button @click="addEgame()" type="primary" icon="plus" style="margin-left: 45px" v-permission="`Content.QuestionGroupTemplate.Add`">添加模板</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="istoggleAdvanced">
                {{advanced ? '收起' : '展开'}}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </div>
          </a-form-item>
        </div>
      </a-form>
    </div>
    <div>
      <a-table 
        :loading="loading"
        :columns="columns" 
        :data-source="dataSource" 
        class="components-table-demo-nested"
        :pagination="{
          current: pageIndex,
          pageSize: pageSize,
          total: total,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onSizeChange,
        }"
      >
        <div slot="status" slot-scope="text,record" v-auth="`Content.QuestionGroupTemplate.Enabled`">
          <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.status == 1" @click="StatusChange(record)"/>
        </div>
        <div slot="action" slot-scope="text,record">
          <a v-permission="`Content.QuestionGroupTemplate.Edit`" @click="edit(text)">
            <a-icon type="edit"/>编辑
          </a>
          <a-popconfirm
            style="margin-left: 15px"
            title="确定删除？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="deleteTemplate(record)"
          >
            <a v-permission="`Content.QuestionGroupTemplate.Delete`" style="color: #f00;">
              <a-icon type="delete"/>删除
            </a>
          </a-popconfirm>
        </div>
      </a-table>
    </div>
    <!-- 编辑添加模板 -->
    <a-modal v-model="ismodle" :title="title" @ok="modleOk" @cancel="closeModle">
      <a-form-model
        ref="ruleForm"
        :model="modleForm"
        :rules="modleRules"
        :label-col="{span:6}"
        :wrapper-col="{span:14}"
      >
        <a-form-model-item ref="name" label="名称" prop="name">
          <a-input v-model="modleForm.name"/>
        </a-form-model-item>
        <a-form-model-item ref="version" label="版本" prop="version">
          <a-input v-model="modleForm.version"/>
        </a-form-model-item>
        <a-form-model-item ref="url" label="url" prop="url">
          <a-input v-model="modleForm.url"/>
        </a-form-model-item>
        <a-form-model-item ref="status" label="状态" prop="status">
          <a-switch :checked="modleForm.status" @change="checkStatus"/>
        </a-form-model-item>
        <a-form-model-item ref="description" label="说明">
          <a-input v-model="modleForm.description" type="textarea"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
const columns = [
  { title: '模板名称', dataIndex: 'name', key: 'name',align:'center',ellipsis:true,width:500 },
  { title: '说明', dataIndex: 'description', key: 'description',align:'center' },
  { title: '关联题目壳数', dataIndex: 'questionGroupNum', key: 'questionGroupNum',align:'center' },
  { title: '版本', dataIndex: 'version', key: 'version',align:'center' },
  { title: '状态', scopedSlots: { customRender: 'status' } , key: 'status',align:'center' },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' },align:'center' },
];
export default {
  name:'Questiongrouptemplate',
  data () {
    return {
      loading:true,
      advanced: false,
      istoggleAdvanced: false, //是否显示展开按钮
      dataSource:[],
      columns,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      options:[],
      selectId:'',
      search:{
        status:undefined
      },
      statusType:'',
      ismodle:false,
      modleForm:{
        name:'',
        version:'',
        url:'',
        status:true,
        description:''
      },
      modleRules:{
        name: [{ required: true, message: '请填写模板名称', trigger: 'blur' }],
        version: [{ required: true, message: '请填写版本', trigger: 'blur' }],
        url: [{ required: true, message: '请填写地址', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      type:'',
      title:'',//弹出框名称
    }
  },
  created () {
    this.getList()
  },
  watch:{
    ismodle(){
      if(!this.ismodle){
        this.resetForm()
      }
    },
  },
  methods: {
    resetSearch(){
      this.search.status = undefined
      this.getList()
    },
    closeModle(){
      this.$refs.ruleForm.resetFields();
    },
    StatusChange(record){
        console.log(record)
        let formData = new FormData()
        formData.append('id',record.id)
        this.$http.checkstatus(formData)
        .then(res => {
                let formData = new FormData()
                formData.append('id',record.id)
                this.$http.templateUpdatestatus(formData)
                .then(res => {
                        record.status = record.status == 1 ? 0 : 1
                        this.$message.destroy();
                        this.$message.success('修改成功')
                        this.loading = false
                
                });
           
        }); 
    },
    onChange(value) {
      console.log(value);
      this.search.AbilityTypeId = value[0]
      this.search.FirstAbilityId = value[1]
      this.search.SecondAbilityId = value[2]
      this.selectId = value
    },
    addEgame(){
      this.type = 'add'
      this.title = '添加'
      this.ismodle = true
    },
    edit(text){
      this.title = '编辑'
      this.type = 'edit'
      this.ismodle = true
      this.modleForm.status = text.status == 1 ? true : false
      this.modleForm.name = text.name || ''
      this.modleForm.version = text.version || ''
      this.modleForm.url = text.url || ''
      this.modleForm.description = text.description || ''
      this.modleForm.id = text.id || ''
    },
    checkStatus(){
        
        if(this.title == '编辑'){
            let formData = new FormData()
            formData.append('id',this.modleForm.id)
            this.$http.checkstatus(formData)
            .then(res => {
                    this.modleForm.status = !this.modleForm.status
              
            });  
        }else{
            this.modleForm.status = !this.modleForm.status
        }
    },
    getList() {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        status:this.search.status
      };
      this.$http.templateList(params)
      .then(res => {
        console.log(res)
          this.dataSource = res.data.data.items
          console.log(this.dataSource)
          this.total = res.data.data.totalCount
          this.loading = false
      });
    },
    modleOk(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          console.log(this.modleForm)
          if(this.type == 'add'){
            this.addTemplateUpdate()
          }else{
            this.updateTemplateUpdate()
          }
        }else{

        }
      })
    },
    addTemplateUpdate(){
      let formData = new FormData()
      for(let key in this.modleForm){
        formData.append(key,this.modleForm[key])
      }
      this.$http.addTemplateUpdate(formData)
      .then(res => {
          this.getList()
          this.$message.success('添加成功')
          this.loading = false
          this.ismodle = false
       
      });
    },
    updateTemplateUpdate(){
      let formData = new FormData()
      formData.append('id',this.modleForm.id)
      for(let key in this.modleForm){
        formData.append(key,this.modleForm[key])
      }
      this.$http.updateTemplateUpdate(formData)
      .then(res => {
          this.getList()
          this.$message.success('修改成功')
          this.loading = false
          this.ismodle = false
       
      });
    },
    deleteTemplate(record){
      let formData = new FormData()
      formData.append('id',record.id)
        this.loading = true
      this.$http.deleteTemplate(formData)
      .then(res => {
        this.loading = false
          this.getList()
          this.$message.success('删除成功')
      
      })
      .catch(err=>{
          this.loading = false
      })
    },
    onPageChange(pageIndex,size) {
      this.pageIndex = pageIndex
      this.getList()
    },
    onSizeChange(pageIndex,size) {
      this.pageIndex = 1
      this.pageSize = size
      this.getList()
    },
    resetForm(){
      this.modleForm = {
        name:'',
        version:'',
        url:'',
        status:true,
        description:''
      }
    }
  }
}
</script>

<style scoped>
 .Questiongrouptemplate >>> .standard-table .alert {
  display: none !important;
}

.Questiongrouptemplate >>>  .searchForm{
  display:flex;
  
}
.Questiongrouptemplate >>> .searchForm .fold{
    width: 91%;
    display:flex;
  }
</style>
